module.exports = __webpack_public_path__ + "img/160.77710196.jpg";